import { ENV_IS_LOCAL_AUTH } from 'constants/env';

export const apiUrlUtil = () =>
  ENV_IS_LOCAL_AUTH ? 'http://localhost:3030' : process.env.NEXT_PUBLIC_API_URL;
